<template>
    <div class="col-md-12">
        <div class="field pull-right">
            <div class="control">
                <button class="btn btn-success" title="Add New Rate" type="button" @click="add">
                    <span class="icon"><i class="fas fa-plus"></i></span><span> Add New Rate</span>
                </button>
            </div>
        </div>
        <br>
        <br>
        <hr>
        <table v-cloak v-if="data.length" class="table is-narrow is-striped is-fullwidth">
            <thead>
                <tr>
                    <th>Rates</th>
                    <th style="width: 18%"></th>
                    <th style="width: 18%"></th>
                    <th style="width: 18%"></th>
                    <th style="width: 18%"></th>
                    <th style="width: 50px"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, key) in data">
                    <td>
                        <input v-model="item.name" :name="'rates[' + key + '][name]'" class="form-control" placeholder="Rate Name" required type="text">
                    </td>
                    <td style="width: 18%">
                        <select v-model="item.frequency" :name="'rates[' + key + '][frequency]'" class="form-control" required @change="$forceUpdate()">
                            <option disabled value="">Select a Frequency</option>
                            <option value="yearly">Annually</option>
                            <option value="monthly">Every x Months</option>
                            <option value="weekly">Every x Weeks on y day</option>
                            <option value="insertion">Every x insertions</option>
                            <option value="single">One Time</option>
                            <option value="custom">Custom Amount</option>
                        </select>
                    </td>
                    <td style="width: 18%">
                        <input v-if="['monthly','weekly','insertion'].includes(item.frequency)" v-model="item.frequency_number" :name="'rates[' + key + '][frequency_number]'" class="form-control" placeholder="Frequency Number (x)" required type="number">
                    </td>
                    <td style="width: 18%">
                        <select v-if="item.frequency === 'weekly'" v-model="item.day_of_week" :name="'rates[' + key + '][day_of_week]'" class="form-control" required @change="$forceUpdate()">
                            <option disabled value="">Day of the Week (y)</option>
                            <option value="monday">Monday</option>
                            <option value="tuesday">Tuesday</option>
                            <option value="wednesday">Wednesday</option>
                            <option value="thursday">Thursday</option>
                            <option value="friday">Friday</option>
                            <option value="saturday">Saturday</option>
                            <option value="sunday">Sunday</option>
                        </select>
                    </td>
                    <td style="width: 18%">
                        <input v-if="item.frequency !== 'custom'" v-model="item.amount" :name="'rates[' + key + '][amount]'" class="form-control" placeholder="Amount" required type="number">
                    </td>
                    <td style="width: 50px">
                        <button class="btn btn-danger" title="Remove Rate" type="button" @click="remove(key)">
                            <span class="icon"><i class="fas fa-trash"></i></span>
                        </button>
                        <input v-model="item.id" :name="'rates[' + key + '][id]'" type="hidden">
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-cloak v-else>
            <p>No Rates Found. <a href="javascript:" @click="add">Add One Now</a></p>
        </div>
    </div>
</template>

<script>
    const emptyRate = {
        id: null,
        name: null,
        amount: null,
        frequency: '',
        frequency_number: null,
        day_of_week: ''
    };

    export default {
        name: 'AdvertisingRates',
        props: {
            data: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        methods: {
            add() {
                this.data.push(structuredClone(emptyRate));
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            },
            remove(index) {
                if(confirm('Are you sure you want to remove this rate?')) {
                    this.$delete(this.data, index);
                    this.$nextTick(() => {
                        this.$forceUpdate();
                    });
                }
            }
        }
    };
</script>
